import ApiEndpointConstants from "../constans/ApiEndpointConstants";
import api from "./API";

export const send_msg = (chat_id, text) => {
  return api.post(`${ApiEndpointConstants.SENDMESSAGE}`, {
    chat_id,
    text,
  });
};
